import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { GridResultsScreen } from '../Grid/GridResultsScreen';
import FormularioPeriodos from '../Formulario/container';
import {EuiFieldNumber, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiSuperSelect} from '@elastic/eui';
import { ActionType, CREATE, UPDATE, STATES } from './constants';
import { Action } from '../../../../components/Menus/interface';
import { Menu } from '../../../../components/Menus';
import ModalApp from '../../../../components/Modal';
import ModalYesNo from '../../../../components/Modal/YesNo';
import { EjercicioFilter } from './EjercicioFilter';
import { Periodo } from '../../../../../../infraestructure/persistence/rest/PeriodosAdapter';

interface Props {
  data: any;
  handleFilter(ejercicio:number): any;
  handleCreate(data: any): any;
  handleRemove(periodo:Periodo): any;
  handleUpdate(periodo:Periodo): any;
  handleOpen(periodo: Periodo, nuevoEstado: string): any;
}

const PeriodosScreen = (props: Props) => {
  const ref:any = useRef();
  const refEj:any = useRef();
  const { data, handleFilter, handleCreate, handleRemove, handleUpdate, handleOpen } = props;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [openRemoveModal, setOpenRemoveModal] = useState(false);
  const [selected, setSelected] = useState<any>(undefined);
  const [actionType, setActionType] = useState<ActionType>(CREATE);

  useEffect(() => { closeModal();setSelected(undefined); if(openRemoveModal){setOpenRemoveModal(false)}}, [data]);

  const closeModal = () => setIsModalVisible(false);
  const showModal = () => setIsModalVisible(true);

  const prepareCreate = useCallback(() => {
    setActionType(CREATE);
    showModal();
  },[])

  const prepareEdit = useCallback(() => {
    setActionType(UPDATE);
    showModal();
  },[])

  const onCreate = useCallback((newData: any) => {
    if (newData && handleCreate) {
      handleCreate(newData)
    }
  },[handleCreate])

  const onUpdate = useCallback((newData: any) => {
    if (handleUpdate && newData) {
      handleUpdate(newData)
    }
  },[handleUpdate])

  const onRemove = useCallback(() => {
    if (selected && handleRemove) {
      if(selected!==undefined){
        setOpenRemoveModal(true)
      }else{
        handleRemove(selected);
      }
    }
  },[selected, handleRemove])

  const onSelected = (selection: any) => {
    setSelected(selection[0])
  }

  const onExport = () =>{
    ref.current && ref.current.onExport();
  }

  const ejercicio = () => {return refEj.current && refEj.current.getEjercicio() }

  const getSelected = useMemo(() =>{
    return actionType.tipo === "U" ? selected : undefined;
  },[actionType,selected])

  const getHandle = useCallback(() =>{
    if(actionType.tipo === "I"){
      return onCreate
    }else{
      return onUpdate
    }
  },[actionType,onCreate,onUpdate])

  const onConfirmRemove = (response:any) => {
    if(response!==undefined && response === true){
      handleRemove(selected);
    }else{
      setOpenRemoveModal(false)
    }
  }
  
  const getStatePeriodo = useCallback(():string=>{
    if(selected){
      switch (selected.estado) {
        case 'Abierto': return STATES.cerrar;
        case 'Cerrado': return STATES.abrir;
        default: return STATES.abrir;
      }
    }else{
      return STATES.abrirCerrar
    }
  },[selected])

  const openPeriodo = useCallback(()=>{
    selected && handleOpen(selected, STATES.abierto)
  },[selected])

  const closePeriodo = useCallback(()=>{
    selected && handleOpen(selected, STATES.cerrado)
  },[selected])

  const getHandleState = useCallback(()=>{
    getStatePeriodo() === STATES.cerrar ? closePeriodo() : openPeriodo()
  },[selected, getStatePeriodo])

  const Actions: Action[] = useMemo(()=> [
    {handle:getHandleState,text:getStatePeriodo(),size:"s", isDisabled:(selected===undefined), color:"warning"},
    {handle:onExport,text:"Exportar",size:"s", isDisabled:false},
    {handle:onRemove,text:"Eliminar Selección",color:"danger",size:"s", isDisabled:(selected===undefined)},
    {handle:prepareEdit,text:"Editar Selección",color:"secondary",size:"s",isDisabled:(selected===undefined)},
    {handle:prepareCreate,text:"Nuevo Periodo",color:"primary",size:"s", isDisabled:false}
  ],[selected,getStatePeriodo,onRemove,prepareEdit,prepareCreate])

  const contentModal = useCallback(() =>  <FormularioPeriodos handle={getHandle()} data={data} selected={getSelected} ejercicio={ejercicio()} onClose={closeModal}/>,[getHandle,getSelected])
  const modal = useMemo(() => <ModalApp isOpen={isModalVisible} title={actionType.title} onClose={closeModal} content={contentModal()}/> ,[isModalVisible,actionType,contentModal])

  const getForm = useMemo(() => {
    return (
        <EuiFlexGroup>
         <EuiFlexItem>
          <EjercicioFilter onChangeFilter={handleFilter} ref={refEj}/>
          </EuiFlexItem>
          <EuiFlexItem>
            <Menu actions={Actions}/>
          </EuiFlexItem>
        </EuiFlexGroup>
    );
  },[selected,refEj])

  const getView = useMemo(() => {
    return (
      <>
        {getForm}
        <EuiSpacer size="s" />
        <GridResultsScreen
          data={data}
          onSelected={onSelected}
          selector={false}
          menu={false}
          ref={ref}
        />
        {modal}
        {openRemoveModal ? <ModalYesNo onClose={onConfirmRemove} isOpen={openRemoveModal}/> : null}
      </>
    )
  },[data, modal, onSelected, openRemoveModal, onConfirmRemove])

  return (
    <>
      {getView}
    </>
);
};

export default PeriodosScreen;